import React from "react";
import { Button } from "@mui/material";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  BRAND_COLORS,
  SHADOW_COLORS,
  STATUS_COLORS,
  TEXT_COLORS,
} from "../../../style/colors";

const variantStyles = {
  primary: {
    backgroundColor: BRAND_COLORS.ACCENT,
    color: TEXT_COLORS.LIGHT,
    borderColor: BRAND_COLORS.ACCENT,
    "&:hover": {
      backgroundColor: BRAND_COLORS.PRIMARY,
      borderColor: BRAND_COLORS.PRIMARY,
      boxShadow: `0px 4px 12px ${SHADOW_COLORS.PRIMARY}33`,
    },
  },
  secondary: {
    backgroundColor: "transparent",
    color: BRAND_COLORS.ACCENT,
    borderColor: BRAND_COLORS.ACCENT,
    "&:hover": {
      backgroundColor: BACKGROUND_COLORS.SECONDARY,
      borderColor: BRAND_COLORS.ACCENT,
    },
  },
  danger: {
    backgroundColor: STATUS_COLORS.ERROR,
    color: TEXT_COLORS.LIGHT,
    borderColor: STATUS_COLORS.ERROR,
    "&:hover": {
      backgroundColor: STATUS_COLORS.ERROR_LIGHT,
      borderColor: STATUS_COLORS.ERROR_LIGHT,
    },
  },
  ghost: {
    backgroundColor: BACKGROUND_COLORS.CARD,
    color: TEXT_COLORS.PRIMARY,
    borderColor: BORDER_COLORS.SECONDARY,
    "&:hover": {
      backgroundColor: BACKGROUND_COLORS.SECONDARY,
      borderColor: BORDER_COLORS.PRIMARY,
    },
  },
};

const AppButton = ({
  variantType = "primary",
  sx,
  children,
  ...props
}) => {
  const resolvedVariant = variantType === "secondary" ? "outlined" : "contained";

  return (
    <Button
      variant={resolvedVariant}
      disableElevation
      sx={{
        minHeight: 40,
        borderRadius: 2.5,
        px: 2,
        fontSize: "0.875rem",
        fontWeight: 600,
        textTransform: "none",
        boxShadow: "none",
        ...variantStyles[variantType],
        ...sx,
      }}
      {...props}>
      {children}
    </Button>
  );
};

export default AppButton;
